<template>
  <vxe-grid auto-resize :data="tableData" :columns="tablePoint">
    <template v-slot:status="{ row }">
      <el-tag
        size="mini"
        :type="row.linePointStatus === 'Y' ? 'light' : 'warning'"
      >
        {{ row.linePointStatusName }}
      </el-tag>
    </template>
    <template v-slot:opt="{ row }">
      <div>
        <el-tooltip class="item" effect="dark" content="查看" placement="top">
          <i
            class="el-icon-view tool-btn"
            @click="
              $emit('openEditPointDialog', {
                type: 'detail',
                code: row.linePointCode,
              })
            "
          ></i>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="编辑" placement="top">
          <i
            class="el-icon-edit tool-btn"
            @click="
              $emit('openEditPointDialog', {
                type: 'edit',
                code: row.linePointCode,
              })
            "
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          content="删除"
          placement="top"
          v-if="row.linePointStatus != 'N'"
        >
          <i
            class="el-icon-delete tool-btn"
            v-if="row.linePointStatus != 'N'"
            @click="del(row.linePointCode)"
          ></i>
        </el-tooltip>
      </div>
    </template>
  </vxe-grid>
</template>

<script>
import tablePoint from './table-point'
import BaseTable from '@/mixins/base-table'
export default {
  props: {
    lineCode: String,
  },
  mixins: [BaseTable],
  data() {
    return {
      tableData: [],
      loading: false,
      tablePoint: tablePoint(),
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.$api
        .contractLinePointListApi({
          lineCode: this.lineCode,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    del(code) {
      this.$confirm('确认要删除该记录吗？', '确认信息', {
        type: 'warning',
      }).then(() => {
        this.$api
          .contractLinePointDelApi({ linePointCode: code })
          .then((res) => {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success',
            })
            this.getData()
          })
      })
    },
  },
}
</script>
